import React from 'react';

import CompanyAvatar from 'containers/components/avatars/CompanyAvatar';
import ContactAvatar from 'containers/components/avatars/ContactAvatar';
import OpportunityIcon from 'containers/opportunities/components/icons/OpportunityIcon';
import { IconThreeRow, ImageRow, OneRow, ThreeRow, TwoRow } from '../rows';

const ENTITY_FORMATS = {
    // Icon + Three row format: icon, label, extraInfo, extraInfo3
    companies: 'companyRow',
    empresas: 'companyRow',
    expedientes: 'opportunityRow',
    contacts: 'contactRow',
    contactos: 'contactRow',
    // Two row format: label, extraInfo
    productos: 'twoRow',
    products: 'twoRow',
    // Image row format: avatar + label
    fullusuarios: 'imageRow',
    usuarios: 'imageRow',
    users: 'imageRow',
    viewusuariosfullname: 'imageRow',
    // Company rates: same as companies but with rate info
    companyrates: 'companyRatesRow',
};

const renderOption = (option, format) => {
    switch (format) {
        case 'companyRow':
            return (
                <IconThreeRow
                    icon={<CompanyAvatar id={option.value} size="small" />}
                    label={option.label}
                    subLabel={option.ExtraInfo || '-'}
                    subSubLabel={option.ExtraInfo3 || '-'}
                />
            );
        case 'contactRow':
            return (
                <IconThreeRow
                    icon={<ContactAvatar id={option.value} size="small" />}
                    label={option.label}
                    subLabel={option.ExtraInfo || '-'}
                    subSubLabel={option.ExtraInfo3 || '-'}
                />
            );
        case 'opportunityRow':
            return (
                <IconThreeRow
                    icon={
                        <OpportunityIcon
                            expirationDays={option.ExtraInfo4}
                            lost={option.ExtraInfo6}
                            won={option.ExtraInfo5}
                        />
                    }
                    label={option.label}
                    subLabel={option.ExtraInfo || '-'}
                    subSubLabel={option.ExtraInfo3 || '-'}
                />
            );
        case 'threeRow':
            return (
                <ThreeRow
                    label={option.label}
                    subLabel={option.ExtraInfo || '-'}
                    subSubLabel={option.ExtraInfo3 || '-'}
                />
            );
        case 'twoRow':
            return <TwoRow label={option.label} subLabel={option.ExtraInfo || '-'} />;
        case 'imageRow':
            return <ImageRow id={option.value} label={option.label} />;
        case 'companyRates':
            return (
                <ThreeRow
                    label={option.label}
                    subLabel={option.ExtraInfo2 || '-'}
                    subSubLabel={option.ExtraInfo || '-'}
                />
            );
        case 'companyRatesRow':
            return (
                <IconThreeRow
                    icon={<CompanyAvatar id={option.value} size="small" />}
                    label={option.label}
                    subLabel={option.ExtraInfo2 || '-'}
                    subSubLabel={option.ExtraInfo || '-'}
                />
            );
        default:
            return <OneRow label={option.label} />;
    }
};

/**
 * Creates a customOption function for hoi-poi-ui Select component
 * @param {string} list - Entity type (companies, contacts, etc.)
 * @param {function} customOptionProp - Optional custom renderer
 * @returns {function} customOption function compatible with hoi-poi-ui Select
 */
const createCustomOption = (list, customOptionProp) => {
    // customOption receives (option, getMatchingCharacters) from hoi-poi-ui
    return (option, getMatchingCharacters) => {
        // Use custom formatter if provided
        if (customOptionProp) return customOptionProp(option, getMatchingCharacters);

        // Get format type based on list
        const format = ENTITY_FORMATS[list];

        return renderOption(option, format);
    };
};

export default createCustomOption;
